/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(value, min, max) {
  if (min == null) {
    min = value;
  }
  return value < min ? min : max != null && value > max ? max : value;
};
exports.default = _default;